module.exports = __webpack_public_path__ + "img/04_title.159258df.png";